(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxCustomControl', {
		bindings: {
			label: '@',
			value: '=?',
			value2: '=?',
			value3: '=?',
			value4: '=?',
			value5: '=?',
			require: '=?',
			controlName: '@',
		},
		controller: function MxCustomControl() {},
		controllerAs: 'vm',
		template: [
			'$attrs',
			function template(attr) {
				// ng-model is necessary for custom validation, ex. in recipient-picker
				return (
					'<' +
					attr.controlName +
					' value="vm.value" value2="vm.value2" value3="vm.value3" value4="vm.value4" value5="vm.value5" require="vm.require" label="{{vm.label}}" ng-model="vm.model"> </' +
					attr.controlName +
					'>'
				);
			},
		],
	});
})();
